export default __webpack_public_path__ + "static/media/logo.ce4178b8.svg";